module.exports = __webpack_public_path__ + "img/collection-weddingRingsFinishes.4a906d2.webp";